export default __webpack_public_path__ + "static/media/V460MANC3.d17327f7.pdf";